// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workingTemplateNavBar {
  width: 100%;
  height: 70px;
  display: flex;
  align-content: space-between;
  padding-top: 14px;
  background-color: #f3f4f6;
}
.workingTemplateNavBar .leftContainer {
  display: inline-block;
}
.workingTemplateNavBar .leftContainer .closeIconWrapper {
  padding: 16px;
  padding-top: 10px;
}
.workingTemplateNavBar .rightContainer {
  margin-left: auto;
  display: inline-block;
  padding-right: 24px;
}
.workingTemplateNavBar .rightContainer .cancellation {
  background: #ffffff;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #505054;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 10px;
  width: 62px;
  height: 42px;
  display: inline-block;
}
.workingTemplateNavBar .rightContainer .nextButton {
  background: #075453;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 10px;
  width: 62px;
  height: 42px;
  display: inline-block;
  margin-left: 14px;
}`, "",{"version":3,"sources":["webpack://./src/screens/recoveryContractModification/navbar/navBar.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,iBAAA;EACA,yBAAA;AACJ;AAAI;EACI,qBAAA;AAER;AADQ;EACI,aAAA;EACA,iBAAA;AAGZ;AAAI;EACI,iBAAA;EACA,qBAAA;EACA,mBAAA;AAER;AADQ;EACI,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAGZ;AADQ;EACI,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAGZ","sourcesContent":[".workingTemplateNavBar {\n    width: 100%;\n    height: 70px;\n    display: flex;\n    align-content: space-between;\n    padding-top: 14px;\n    background-color: #f3f4f6;\n    .leftContainer {\n        display: inline-block;\n        .closeIconWrapper {\n            padding: 16px;\n            padding-top: 10px;\n        }\n    }\n    .rightContainer {\n        margin-left: auto;\n        display: inline-block;\n        padding-right: 24px;\n        .cancellation {\n            background: #ffffff;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            text-align: center;\n            color: #505054;\n            border: 1px solid #e1e1e1;\n            border-radius: 8px;\n            padding: 10px;\n            width: 62px;\n            height: 42px;\n            display: inline-block;\n        }\n        .nextButton {\n            background: #075453;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            text-align: center;\n            color: #ffffff;\n            border: 1px solid #e1e1e1;\n            border-radius: 8px;\n            padding: 10px;\n            width: 62px;\n            height: 42px;\n            display: inline-block;\n            margin-left: 14px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
